import React from "react";
import styled from "styled-components";
import RollerIcon from "../../assets/svg/Services/RollerIcon";
import MobileIcon from "../../assets/svg/Services/Mobile";
import CustomIcon from "../../assets/svg/Services/Custom";
import MonitorIcon from "../../assets/svg/Services/MonitorIcon";
import BrowserIcon from "../../assets/svg/Services/BrowserIcon";
import PrinterIcon from "../../assets/svg/Services/PrinterIcon";
import IotIcon from "../../assets/svg/Services/Iot";

export default function ServiceBox({ icon, title, subtitle }) {
  let getIcon;
  switch (icon) {
    case "ai":
      getIcon = <RollerIcon />;
      break;
    case "mobile":
      getIcon = <MobileIcon />;
      break;
    case "web":
      getIcon = <BrowserIcon />;
      break;
    case "qa":
      getIcon = <MonitorIcon />;
      break;
    case "custom":
      getIcon = <CustomIcon />;
      break;
    case "devops":
      getIcon = <PrinterIcon />;
      break;
    case "iot":
      getIcon = <IotIcon />;
      break;
    default:
      getIcon = <RollerIcon />;
      break;
  }


  return (
    <Wrapper className="flex flexColumn">
      <IconStyle>{getIcon}</IconStyle>
      <TitleStyle className="font20 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const IconStyle = styled.div`
  svg {
    width: 42px;
    height: 42px;
  }
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 40px 0;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;